require('./bootstrap');

import Vue from 'vue'

import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw'
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';

import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'

import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

import { ZiggyVue } from 'ziggy';
import { Ziggy } from './ziggy';

import VueEventBus from "vue-geventbus";

dayjs.locale('zh-tw');
dayjs.extend(relativeTime);
dayjs.extend(isBetween);

Vue.prototype.dayjs = dayjs;

InertiaProgress.init()

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    title: title => (title ? `${title} | Foody Home 吃貨家` : 'Foody Home 吃貨家'),
    setup({ el, app, props, plugin }) {
        Vue.use(plugin)
        Vue.use(PrimeVue, {
            locale: {
                firstDayOfWeek: 0,
                dayNames: [
                    "星期日",
                    "星期一",
                    "星期二",
                    "星期三",
                    "星期四",
                    "星期五",
                    "星期六",
                ],
                dayNamesShort: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
                dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
                monthNames: [
                    "一月",
                    "二月",
                    "三月",
                    "四月",
                    "五月",
                    "六月",
                    "七月",
                    "八月",
                    "九月",
                    "十月",
                    "十一月",
                    "十二月",
                ],
                monthNamesShort: [
                    "一月",
                    "二月",
                    "三月",
                    "四月",
                    "五月",
                    "六月",
                    "七月",
                    "八月",
                    "九月",
                    "十月",
                    "十一月",
                    "十二月",
                ],
                today: "今天",
                clear: "清除",
                dateFormat: "mm/dd/yy",
                weekHeader: "週數",
            },
        })
        Vue.use(ToastService);
        Vue.use(ConfirmationService);
        Vue.directive('tooltip', Tooltip);
        Vue.use(ZiggyVue, Ziggy)
        Vue.use(VueEventBus)
        Vue.component("Head", Head)
        Vue.component("Link", Link)

        return new Vue({
            render: h => h(app, props),
        }).$mount(el)
    },
});